module.exports = __webpack_public_path__ + "img/WhatsApp.5d3f37af.svg";